define( [
	"./class2type"
], function( class2type ) {
	"use strict";

	return class2type.hasOwnProperty;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/hasOwn.js
 ** module id = 192
 ** module chunks = 0
 **/